module.exports = __webpack_public_path__ + "img/male-youngadult-hand.c45e36f8.svg";